import React, { useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Modal, Field, Input, Btn } from "@/components/erp/ui";
import { toast } from "sonner";

// Ganti password sendiri; wajib (tidak bisa ditutup) bila admin memberi password sementara
export const ChangePasswordModal = ({ forced, onClose }) => {
  const { checkAuth, logout } = useAuth();
  const [f, setF] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const save = async () => {
    if (f.new_password !== f.confirm) return toast.error("Konfirmasi password tidak sama");
    setBusy(true);
    try { await api.post("/auth/change-password", f); toast.success("Password berhasil diganti"); if (forced) { window.location.reload(); return; } await checkAuth(); onClose?.(); }
    catch (e) { const d = e.response?.data?.detail; toast.error(typeof d === "string" ? d : "Gagal mengganti password"); }
    setBusy(false);
  };
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  return (
    <Modal open onClose={forced ? null : onClose} title={forced ? "Buat Password Baru" : "Ganti Password"}
      footer={<>{forced ? <Btn variant="ghost" data-testid="chpw-logout" onClick={logout}>Keluar</Btn> : <Btn variant="ghost" data-testid="chpw-cancel" onClick={onClose}>Batal</Btn>}<Btn data-testid="chpw-save" disabled={busy || !f.current_password || !f.new_password} onClick={save}>{busy ? "Menyimpan…" : "Simpan Password"}</Btn></>}>
      <div className="space-y-3" data-testid="change-password-modal">
        {forced && <p data-testid="chpw-forced-note" className="text-sm rounded-lg bg-amber-50 border border-amber-200 text-amber-800 px-3 py-2">Admin utama memberi Anda password sementara. Buat password baru Anda sendiri sebelum melanjutkan.</p>}
        <Field label={forced ? "Password sementara" : "Password lama"}><Input data-testid="chpw-current" type="password" value={f.current_password} onChange={set("current_password")} /></Field>
        <Field label="Password baru (min. 8 karakter, huruf + angka)"><Input data-testid="chpw-new" type="password" value={f.new_password} onChange={set("new_password")} /></Field>
        <Field label="Ulangi password baru"><Input data-testid="chpw-confirm" type="password" value={f.confirm} onChange={set("confirm")} /></Field>
      </div>
    </Modal>
  );
};
